import { LocationQuery } from 'vue-router';
import { http } from '../../helpers/http.helper';
import { ApiResource } from './../../models/api-resource.interface';
import { City } from './city.interface';

export class CityService {
   async getCities(query: LocationQuery) {
      const response = await http.get<ApiResource<Array<City>>>(`/nxt-cities`, { params: { ...query } });
      return response.data.data;
   }
}
